import React from 'react';
import CardSecurityCode from 'react-card-security-code';
import { StyleSheet, css } from '../utility/paypalAphrodite';
import AppStore from '../stores/AppStore';
import AppActions from '../actions/AppActions';
import { localsMessages, guestLocalsMessages } from '../utility/getTemplateData';

const guestMessages = guestLocalsMessages('guest/guestForm');
const errorMessages = localsMessages('errors/service');

const STYLES = StyleSheet.create({
  cvvComponent: {
    display: 'flex'
  },
  cvvField: {
    width: '145px'
  },
  cvvNote: {
    maxWidth: '140px',
    marginLeft: '10px',
    fontSize: '10px',
    display: 'flex',
    alignItems: 'center'
  },
  warning: {
    backgroundColor: '#fffbf5',
    marginBottom: '20px'
  }
});

class CVVComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      securityCode: '',
      cardSpec: AppStore.getCardSpec().cardSpec,
      errorMessageCSC: '',
    }
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  handleChangeSecurityCode(securityCode) {
    this.setState({ securityCode: securityCode });
    this.props.handleSecurityCodeChange(securityCode);
  }

  handleFieldFocus(fieldName) {
    this.setState({ [fieldName]: '' });
  }

  /*
  * Handle error message for selected field
  */
  handleFieldBlur(value, fieldName, fieldRequired, fieldInvalid) {
    let newErrorState = {};

    if (value) {
      newErrorState = { [fieldName]: this.validateInputValue(value, fieldName, fieldInvalid) }
    } else {
      newErrorState = { [fieldName]: errorMessages[fieldRequired] }
    }

    this.setState(newErrorState)
  }

  /*
  * Validate input
  */
  validateInputValue(value, fieldName, fieldInvalid) {

    let { cardSpec : { fields: { csc = {} } } } = this.state;

    if (fieldName === 'errorMessageCSC') {
      let cscLen = value && value.length
      let cscMax = csc.maxlength
      let cscMin = csc.minlength || cscMax

      if (!(cscLen >= cscMin && cscLen <= cscMax)) {
        return errorMessages[fieldInvalid]
      }
    }

    return ''
  }

  render() {
    let { cscplaceholder, csc: cscLabel, cscnote } = guestMessages.guestLabels;
    cscnote = cscnote && cscnote.replace('{csc}', cscLabel.toLowerCase());

    return (
      <div className={`cvv_component ${css(STYLES.cvvComponent)}`} id="cvv_component">
        <div  className={`cvv_field ${css(STYLES.cvvField)}`}>
          <CardSecurityCode
              showIsRequiredError={true}
              label={cscLabel}
              placeholder={cscplaceholder}
              errorMessage={this.state.errorMessageCSC}
              handleChangeSecurityCode={(value) => this.handleChangeSecurityCode(value)}
              handleFocus={(value) => this.handleFieldFocus('errorMessageCSC')}
              handleBlur={(value) => this.handleFieldBlur(value, 'errorMessageCSC', 'REQUIRED_SECURITY_CODE', 'INVALID_SECURITY_CODE')}
              cardSpec={this.state.cardSpec}/>
        </div>
        <label className={css(STYLES.cvvNote)}>{cscnote}</label>
      </div>
    );
  }
};

export default CVVComponent;



// WEBPACK FOOTER //
// ./containers/cvv-component.js